import { useTranslation } from 'react-i18next';
import { BuyClickAndCollect } from 'autogen/translation-keys/trans-website-shared-buttons';
import { ButtonWithIcon, ButtonWithSpinner } from 'components/Button';
import Icon from 'components/Icon';
import type { ProductActionProps } from '../../shared/types';
import { useOpenClickAndCollectCallback } from './hooks/useOpenClickAndCollect';

function ClickAndCollectButton({
    params,
    trackingInfo,
    children,
    ...restProps
}: ProductActionProps['ClickAndCollect']) {
    const { t } = useTranslation();
    const { productId } = params;
    const onClickHandler = useOpenClickAndCollectCallback({ productId, trackingInfo });

    return (
        <ButtonWithSpinner onClick={onClickHandler} variant="primary" type="button" {...restProps}>
            {children || t(BuyClickAndCollect)}
        </ButtonWithSpinner>
    );
}

function ClickAndCollectButtonCompact({ params, trackingInfo, ...restProps }: ProductActionProps['ClickAndCollect']) {
    const { productId } = params;
    const { t } = useTranslation();
    const onClickHandler = useOpenClickAndCollectCallback({ productId, trackingInfo });

    return (
        <ButtonWithIcon
            icon={<Icon type="Pin" size={16} />}
            onClick={onClickHandler}
            variant="secondary"
            type="button"
            aria-label={t(BuyClickAndCollect)}
            {...restProps}
        />
    );
}

export default Object.assign(ClickAndCollectButton, {
    Compact: ClickAndCollectButtonCompact
});
